import { SVGProps } from 'react'

export const Grid = ({
  size = 24,
  className,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.75 3H3V3.75V10.25V11H3.75H10.25H11V10.25V3.75V3H10.25H3.75ZM4.5 9.5V4.5H9.5V9.5H4.5ZM3.75 13H3V13.75V20.25V21H3.75H10.25H11V20.25V13.75V13H10.25H3.75ZM4.5 19.5V14.5H9.5V19.5H4.5ZM17 14.5C15.6193 14.5 14.5 15.6193 14.5 17C14.5 18.3807 15.6193 19.5 17 19.5C18.3807 19.5 19.5 18.3807 19.5 17C19.5 15.6193 18.3807 14.5 17 14.5ZM13 17C13 14.7909 14.7909 13 17 13C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17ZM13.75 3H13V3.75V10.25V11H13.75H20.25H21V10.25V3.75V3H20.25H13.75ZM14.5 9.5V4.5H19.5V9.5H14.5Z"
      fill="currentColor"
    />
  </svg>
)
